import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import {
  Layout,
  Dashboard,
  LoginForm,
  ChangePassword,
  PageNotFound,
  AppContent,
  AppContentForm,
  AppPost,
  AppPostForm,
  PostContent,
  PostContentForm,
  GuestUsers,
  AthleteUsers,
  Facilities,
  FacilityDetail,
  Bookings,
  Payouts,
} from "scenes";
import Challenges from "scenes/challenges/Challenges";
import Sports from "scenes/sports/Sports";
import Highlights from "scenes/highlights/Highlights";
import FAQs from "scenes/faqs/FAQs";
import Support from "scenes/support/Support";
import AdminUsers from "scenes/admin-users/AdminUsers";
import Roles from "scenes/role/Roles";
import RoleAccess from "scenes/role-access/RoleAccess";
import { PrivateRoutes, PublicRoutes } from "utilities/authRoutes/AuthRoutes";

const RoutesConfig = () => (
  <Routes>
    <Route element={<PrivateRoutes />}>
      <Route path="/" element={<Layout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="guest-users" element={<GuestUsers />} />
        <Route path="athlete-users" element={<AthleteUsers />} />
        <Route path="facilities" element={<Facilities />} />
        <Route path="facilities/:id" element={<FacilityDetail />} />
        <Route path="bookings" element={<Bookings />} />
        <Route path="payouts" element={<Payouts />} />
        <Route path="app-content" element={<AppContent />} />
        <Route path="app-content/add" element={<AppContentForm />} />
        <Route path="app-content/edit/:id" element={<AppContentForm />} />
        <Route path="app-post" element={<AppPost />} />
        <Route path="app-post/add" element={<AppPostForm />} />
        <Route path="app-post/edit/:id" element={<AppPostForm />} />
        <Route path="post-content" element={<PostContent />} />
        <Route path="post-content/add" element={<PostContentForm />} />
        <Route path="post-content/edit/:id" element={<PostContentForm />} />
        <Route path="challenges" element={<Challenges />} />
        <Route path="sports" element={<Sports />} />
        <Route path="highlights" element={<Highlights />} />
        <Route path="faqs" element={<FAQs />} />
        <Route path="support" element={<Support />} />
        <Route path="admin-users" element={<AdminUsers />} />
        <Route path="role" element={<Roles />} />
        <Route path="role-access" element={<RoleAccess />} />
        <Route path="change-password" element={<ChangePassword />} />
      </Route>
    </Route>

    <Route element={<PublicRoutes />}>
      <Route path="login" element={<LoginForm />} />
    </Route>
    <Route path="*" element={<PageNotFound />} />
  </Routes>
);

export default RoutesConfig;
